import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import {
  Button,
  Modal as DefaultModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalTitle,
  Update,
  EditButton,
  HighlightedInput,
} from "prospect-path-components";

import publishPromotions from "../../../actions/product-management/PublishPromotions";

const Modal = styled(DefaultModal)`
  max-width: 29rem;
  margin-top: 10% !important;
`;

const Heading = styled.h3`
  color: #1d1e1e;
  font-family: "Cerebri Sans", sans-serif;
  margin-top: 0rem;
  margin-bottom: 0.3rem;
`;

const UpdateContainer = styled.div`
  margin-bottom: 1.5rem;
`;

const ActionContainer = styled.div`
  display: flex;
`;

const EmailContainer = styled.span`
  margin-right: 1.5rem;
`;

class PromoteConfirmationModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      emailEdits: {},
    };

    this.emailIsEdited = this.emailIsEdited.bind(this);
    this.handleEditEmail = this.handleEditEmail.bind(this);
    this.handleEditEmailAddress = this.handleEditEmailAddress.bind(this);
    this.publishChanges = this.publishChanges.bind(this);
  }
  emailIsEdited(promotionMethodId) {
    return promotionMethodId in this.state.emailEdits;
  }
  handleEditEmail(promotionMethodId) {
    const emailEdits = { ...this.state.emailEdits };

    if (this.emailIsEdited(promotionMethodId)) {
      delete emailEdits[promotionMethodId];
    } else {
      emailEdits[promotionMethodId] = this.props.promotionMethods.find(
        (promotionMethod) => promotionMethod.id === promotionMethodId
      ).email;
    }
    this.setState({ emailEdits });
  }
  handleEditEmailAddress(promotionMethodId, email) {
    this.setState({
      emailEdits: {
        ...this.state.emailEdits,
        [promotionMethodId]: email,
      },
    });
  }
  publishChanges() {
    this.props
      .publishPromotions(
        this.props.teamId,
        this.props.productId,
        this.props.promotionMethods.map(
          (promotionMethod) => promotionMethod.id
        ),
        this.state.emailEdits
      )
      .then(() => {
        this.props.closeModal(true);

        // Jump to the top of the page
        window.scroll(0, 0);
      });
  }
  componentDidMount() {
    Modal.setAppElement("body");
  }
  render() {
    return (
      <Modal {...this.props}>
        <ModalHeader>
          <ModalTitle>Confirm Your Updates</ModalTitle>
        </ModalHeader>
        <ModalBody>
          {this.props.promotionMethods.map((promotionMethod) => (
            <UpdateContainer key={promotionMethod.id}>
              <Heading>{promotionMethod.name}</Heading>
              {promotionMethod.product_distribution_method_type.reference ===
              "api" ? (
                <Update icon highlighted>
                  Direct Integration
                </Update>
              ) : (
                <div>
                  {this.emailIsEdited(promotionMethod.id) ? (
                    <HighlightedInput
                      value={this.state.emailEdits[promotionMethod.id]}
                      onChange={(event) =>
                        this.handleEditEmailAddress(
                          promotionMethod.id,
                          event.target.value
                        )
                      }
                    />
                  ) : (
                    <EmailContainer style={{ "margin-right": "0.7rem" }}>
                      {promotionMethod.email}
                    </EmailContainer>
                  )}
                  {/*
                     The button is wrapped in a span because the onClick prop isn't
                     passed to the inner button element of EditButton at the moment.
                    */}
                  <span
                    role="button"
                    tabIndex="0"
                    onClick={() => this.handleEditEmail(promotionMethod.id)}
                  >
                    <EditButton style={{ display: "inline-block" }} />
                  </span>
                </div>
              )}
            </UpdateContainer>
          ))}
        </ModalBody>
        <ModalFooter>
          <div style={{ marginLeft: "auto" }}>
            <Button
              style={{ marginRight: "1rem" }}
              onClick={() => this.props.closeModal()}
            >
              Cancel
            </Button>
            <Button onClick={this.publishChanges} color="primary">
              Confirm Updates
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  publishPromotions: (teamId, productId, promotionMethodIds, emailChanges) =>
    dispatch(
      publishPromotions(teamId, productId, promotionMethodIds, emailChanges)
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PromoteConfirmationModal);
